import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { convertEpochToDate } from '../../../utils';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  tableCell: {
    backgroundColor: '#f2f2f2',
    padding: '10px',
    fontWeight: 'bold',
    border: '1px solid #ddd',
  },
  blueText: {
    color: '#1F4A7C',
  },
});

const data = [
  {
    Sl: 1,
    Name: 'Sanket',
    FormNo: 'Appendix10',
    "Application/RefNo": 'HPBPA20241200011',
    'Application Fee': '22000',
    'Downloads': 'View',
    'Status': 'Paid',
    'Payment Mode': 'E-Cash Payment',
    'DD/Challan Date': '2024-01-29',
    'Payment Update Date' : 'Doc1, Doc2',
    'Action': 'Approved',
  },
  {
    Sl: 2,
    Name: 'Rahul',
    FormNo: 'Form11',
    "Application/RefNo": 'HPBPA20241200012',
    'Application Fee': '21000',
    'Downloads': 'View',
    'Status': 'Paid',
    'Payment Mode': 'Manpura',
    'Payment Mode': 'E-Cash Payment',
    'Payment Update Date' : 'Doc1, Doc2',
    'Action': 'Approved',
  },
  {
    Sl: 3,
    Name: 'Sakshi',
    FormNo: 'Form11',
    "Application/RefNo": 'HPBPA20241200013',
    'Application Fee': '23000',
    'Downloads': 'View',
    'Status': 'Paid',
    'Payment Mode': 'Manpura',
    'Payment Mode': 'E-Cash Payment',
    'Payment Update Date' : 'Doc1, Doc2',
    'Action': 'Approved',
  },
  {
    Sl: 4,
    Name: 'Rahul',
    FormNo: 'Form34',
    "Application/RefNo": 'HPBPA20241200014',
    'Application Fee': '21000',
    'Downloads': 'View',
    'Status': 'Paid',
    'Payment Mode': 'Manpura',
    'Payment Mode': 'E-Cash Payment',
    'Payment Update Date' : 'Doc1, Doc2',
    'Action': 'Approved',
  },
  {
    Sl: 5,
    Name: 'Sunil',
    FormNo: 'Form26',
    "Application/RefNo": 'HPBPA20241200015',
    'Application Fee': '32000',
    'Downloads': 'View',
    'Status': 'Paid',
    'Payment Mode': 'E-Cash Payment',
    'DD/Challan Date': '2024-01-29',
    'Payment Update Date' : 'Doc1, Doc2',
    'Action': 'Approved',
  },
  {
    Sl: 6,
    Name: 'Sunita',
    FormNo: 'Form11',
    "Application/RefNo": 'HPBPA20241200016',
    'Application Fee': '32000',
    'Downloads': 'View',
    'Status': 'Paid',
    'Payment Mode': 'Manpura',
    'DD/Challan Date': '2024-01-29',
    'Payment Mode': 'E-Cash Payment',
    'Action': 'Approved',
  },
  {
    Sl: 7,
    Name: 'Aanchal',
    FormNo: 'Form11',
    "Application/RefNo": 'HPBPA20241200017',
    'Application Fee': '42000',
    'Downloads': 'View',
    'Status': 'Paid',
    'Payment Mode': 'Manpura',
    'DD/Challan Date': '2024-01-29',
    'Payment Mode': 'E-Cash Payment',
    'Action': 'Approved',
  },
  {
    Sl: 8,
    Name: 'Rose',
    FormNo: 'Appendix10',
    "Application/RefNo": 'HPBPA20241200018',
    'Application Fee': '3000',
    'Downloads': 'View',
    'Status': 'Paid',
    'Payment Mode': 'E-Cash Payment',
    'DD/Challan Date': '2024-01-29',
    'Payment Update Date' : 'Doc1, Doc2',
    'Action': 'Approved',
  },
  {
    Sl: 9,
    Name: 'Sunita',
    FormNo: 'Form11',
    "Application/RefNo": 'HPBPA20241200019',
    'Application Fee': '4400',
    'Downloads': 'View',
    'Status': 'Paid',
    'Payment Mode': 'E-Cash Payment',
    'DD/Challan Date': '2024-01-29',
    'Payment Update Date' : 'Doc1, Doc2',
    'Action': 'Approved',
  },
  {
    Sl: 10,
    Name: 'Sunil',
    FormNo: 'Appendix10',
    "Application/RefNo": 'HPBPA20241200020',
    'Application Fee': '2000',
    'Downloads': 'View',
    'Status': 'Paid',
    'Payment Mode': 'E-Cash Payment',
    'DD/Challan Date': '2024-01-29',
    'Payment Update Date' : 'Doc1, Doc2',
    'Action': 'Approved',
  },
];

const InboxTable = ({apiData}) => {
  const classes = useStyles();
  console.log(apiData, "aaaaaaaaa");
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            {Object.keys(data[0]).map((heading) => (
              <TableCell key={heading} className={classes.tableCell}>
                {heading}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody style={{backgroundColor: '#fbfaff'}}>
        {apiData?.Payments?.map((row, index) => (
            <TableRow key={row.id}>
              {/* {Object.keys(row).map((key) => (
                <TableCell key={key} className={key === 'Name' || key === 'Status' ? classes.blueText : ''}>{row[key]}</TableCell>
              ))} */}
              <TableCell>{index + 1}</TableCell>
              <TableCell>{row?.payerName}</TableCell>
              <TableCell>{row?.paymentDetails?.[0]?.businessService}</TableCell>
              <TableCell>{row?.paymentDetails?.[0]?.bill?.consumerCode}</TableCell>
              <TableCell>{row?.totalAmountPaid}</TableCell>
              <TableCell>{"View"}</TableCell>
              <TableCell>{row?.paymentStatus}</TableCell>
              <TableCell>{row?.paymentMode}</TableCell>
              <TableCell> {convertEpochToDate(row?.transactionDate)}</TableCell>
              <TableCell> {convertEpochToDate(row?.auditDetails?.lastModifiedTime)}</TableCell>
              <TableCell>{}</TableCell>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default InboxTable;
